import util from './util'
import sign from './sign'
import * as consts from './const'
import axios from '../http'
import qs from 'qs'
import Config from '../config/config'

export default function request(path, data, callback) {
  var timestamp = new Date().getTime()
  var randomStr = util.getRandomStr(32)
  data.timestamp = timestamp
  data.random_str = randomStr
  data.mtoken = Config.xcMToken
  data.sign = sign.sign(data)
  var url = Config.xcBaseUrl + Config.xcToken + path
  axios.post(url, qs.stringify(data), { withCredentials: false }).then(function(res) {
    return callback(null, res)
  }).catch(function(err) {
    return callback(err)
  })
}



// WEBPACK FOOTER //
// ./src/util/xc-request.js